import React, { FC, lazy }         from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { RouterUtility }                               from '../../../../util';
import { useSuspense }                                 from '../../../../hooks';
import { Flexbox, FlexItem, Page, PageTitleContainer } from '../../../containers';
import { DecisionEngineNav }                           from '../../../components/nav/DecisionEngineNav';
import { SystemDEMAdminsOnly }                         from '../../../components/util/access/RoleAccessControl';

const IntakeQuestionManager = lazy( () => import('./intake-questions/IntakeQuestionManager') );
const ObjectivesManager     = lazy( () => import('./objectives/ObjectivesManager') );
const ActivityManager       = lazy( () => import('./activities/ActivityManager') );
const CategoryManager       = lazy( () => import('./categories/CategoryManager') );
const AssumptionsManager    = lazy( () => import('./assumptions/AssumptionsManager') );
const ResourcesManager      = lazy( () => import('./resources/ResourcesManager') );

const routePaths = {
    home:                    RouterUtility.getRoutePath( 'HOME' ) as string,
    adminIndex:              RouterUtility.getRoutePath( 'ADMIN' ) as string,
    DEMHome:                 RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE' ) as string,
    questions:               RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.QUESTIONS' ) as string,
    objectives:              RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.OBJECTIVES' ) as string,
    objectiveSections:       RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.OBJECTIVES.SECTION' ) as string,
    activities:              RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.ACTIVITIES' ) as string,
    activitiesSections:      RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.ACTIVITIES.SECTION' ) as string,
    categories:              RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.CATEGORIES' ) as string,
    assumptions:             RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.ASSUMPTIONS' ) as string,
    resources:               RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.RESOURCES' ) as string,
    hireTypes:               RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.RESOURCES.HIRE_TYPES' ) as string,
    hireTypesSection:        RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.RESOURCES.HIRE_TYPES.SECTION' ) as string,
    professionalFees:        RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.RESOURCES.FEES' ) as string,
    professionalFeesSection: RouterUtility.getRoutePath( 'ADMIN.DECISION_ENGINE.RESOURCES.FEES.SECTION' ) as string,
};

const DecisionEngineManagerPage: FC = () => {

    let { withSuspense } = useSuspense();

    return (
            <SystemDEMAdminsOnly redirect={ routePaths.home }>
                <Page name={ 'admin-decision-manager' }
                      padMainHorizontal={ false }
                      padMainVertical={ false }>

                    <PageTitleContainer title={ 'Decision Engine Manager' } fluid={ true }/>

                    <Flexbox className={ 'padding-xs-vertical padding-lg-horizontal container--colored-bg-teal' }>

                        <FlexItem noGrow>

                            <DecisionEngineNav secondary inverted color={ 'teal' }/>

                        </FlexItem>

                    </Flexbox>

                    <Switch>
                        <Route path={ routePaths.questions } render={ withSuspense( IntakeQuestionManager ) }/>

                        <Route path={ routePaths.objectiveSections } exact={ true } render={ withSuspense( ObjectivesManager ) }/>
                        <Route path={ routePaths.objectives } render={ withSuspense( ObjectivesManager ) }/>

                        <Route path={ routePaths.activitiesSections } exact={ true } render={ withSuspense( ActivityManager ) }/>
                        <Route path={ routePaths.activities } render={ withSuspense( ActivityManager ) }/>

                        <Route path={ routePaths.categories } render={ withSuspense( CategoryManager ) }/>
                        <Route path={ routePaths.assumptions } render={ withSuspense( AssumptionsManager ) }/>

                        <Route path={ routePaths.hireTypesSection } exact={ true } render={ withSuspense( ResourcesManager ) }/>
                        <Route path={ routePaths.hireTypes } exact={ true } render={ withSuspense( ResourcesManager ) }/>
                        <Route path={ routePaths.professionalFeesSection } exact={ true } render={ withSuspense( ResourcesManager ) }/>
                        <Route path={ routePaths.professionalFees } exact={ true } render={ withSuspense( ResourcesManager ) }/>
                        <Route path={ routePaths.resources } render={ withSuspense( ResourcesManager ) }/>

                        <Redirect to={ routePaths.questions }/>

                    </Switch>

                </Page>
            </SystemDEMAdminsOnly>
    )
};

export default DecisionEngineManagerPage
